import { MouseEvent, useState } from 'react';
import { Box, Menu } from '@mui/material';
import { IIdentityContext } from '@almamedia-legal-insights/types';
import AccountMenuContent from './AccountMenuContent';
import '../translations/i18n';
import AccountMenuButton from './AccountMenuButton';

interface AccountMenuProps {
  identityContext: IIdentityContext;
}

export default function AccountMenu({
  identityContext,
}: Readonly<AccountMenuProps>) {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorElement);

  const handleOpen = (event: MouseEvent) =>
    setAnchorElement(event.currentTarget as HTMLElement);
  const handleClose = () => setAnchorElement(null);

  return (
    <Box sx={{ position: 'relative' }}>
      <AccountMenuButton
        open={open}
        onClick={handleOpen}
        identityContext={identityContext}
      />
      <Menu
        id='account-menu'
        anchorEl={anchorElement}
        open={open}
        onClose={handleClose}
        sx={{ zIndex: 1500 }}
        slotProps={{
          list: {
            'aria-labelledby': 'account-menu-button',
          },
          paper: {
            sx: {
              left: { xs: 0, sm: 'auto' },
              right: { xs: 0, sm: 'auto' },
              width: { sm: 280 },
              maxWidth: { sm: 'none' },
              boxSizing: 'border-box',
            },
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <AccountMenuContent
          identityContext={identityContext}
          closeMenu={handleClose}
        />
      </Menu>
    </Box>
  );
}
